import { Injectable } from '@angular/core';
import { VueTranslationService } from '@vue/vueframework';
@Injectable({
  providedIn: 'root'
})
export class AppTranslationService {
  public constructor(
    private vueTranslationService: VueTranslationService
  ) { }

  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  public getTranslation(bundle: string, key: string, params?: any[]): string {
    return this.vueTranslationService.getTranslationFromBundle(bundle, key, params);
  }

  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  public getTranslationFromErrorMessage(error: any, defaultMsg: string): string {
    let text;
    if (error) {
      const errorData = Array.isArray(error) ? error[ 0 ] : error;
      const errorCode = errorData.code;
      if (errorCode && errorCode !== 'unknownServerError') {
        const errorKey = errorCode.indexOf('.') >= 0 ? errorCode.slice(errorCode.indexOf('.') + 1) : errorCode;
        const errorBundle = errorCode.indexOf('.') >= 0 ? errorCode.slice(0, errorCode.indexOf('.')) : '';
        text = this.getTranslation(
          errorBundle,
          errorKey,
          errorData.parameters
        );
      }
    }
    return text ? text : defaultMsg;
  }
}
